(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/reductions.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/reductions.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.collections = svs.matchen.collections || {};

  svs.matchen.collections.Reductions = Backbone.Collection.extend({
    initialize: function() {
      if (arguments.length === 0) {
        this.setDefaultReductions({ silent: true });
      }
    },

    setDefaultReductions: function(options) {
      this.set(
        [
          {
            id: 'HOME',
            label: 'Hemma',
            labelNewPixApi: 'Home',
            type: 'H',
            selected: false,
            requesting: false
          },
          {
            id: 'DRAW',
            label: 'Oavgjort',
            labelNewPixApi: 'Tie',
            type: 'D',
            selected: false,
            requesting: false
          },
          {
            id: 'AWAY',
            label: 'Borta',
            labelNewPixApi: 'Away',
            type: 'A',
            selected: false,
            requesting: false
          }
        ],
        options
      );
    },

    isAnyReductionsSelected: function() {
      return this.numberOfSelectedReductions() > 0;
    },

    numberOfSelectedReductions: function() {
      return this.where({ selected: true }).length;
    },

    isMaximumNumberOfReductionsSelected: function() {
      return this.numberOfSelectedReductions() == 2;
    },

    isHomeReduced: function() {
      return this.isReduced('HOME');
    },

    isDrawReduced: function() {
      return this.isReduced('DRAW');
    },

    isAwayReduced: function() {
      return this.isReduced('AWAY');
    },

    isReduced: function(id) {
      return this.findWhere({ id: id }).get('selected');
    },

    getXpertenReductionString: function() {
      return _.map(this.where({ selected: false }), function(reduction) {
        return reduction.get('type');
      }).join('');
    },

    getUnselectedReductionsAsArray: function() {
      return _.reduce(
        this.models,
        function(memo, model) {
          if (!model.get('selected')) {
            memo.push(model.get('id'));
          }
          return memo;
        },
        []
      );
    },

    getSelectedReductionsString: function() {
      return _.map(this.where({ selected: true }), function(reduction) {
        return reduction.get('labelNewPixApi');
      }).join('And');
    }
  });
})(Backbone, _, svs);


 })(window);